export const SET_ALERT = 'SET_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

export const setAlert = (alert, severity, title, role) => {
  return {
    type: SET_ALERT,
    alert: alert,
    severity: severity,
    title: title,
    role: role
  };
};

export const hideAlert = () => {
  return {
    type: HIDE_ALERT
  };
};